import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentBlog3PostsDestaque {
    constructor() {

        this.slider = document.querySelector(".swiper--component-blog_3_posts_destaque")
        this.navigationPrev = document.querySelector(".slider-button-prev--component-blog_3_posts_destaque")
        this.navigationNext = document.querySelector(".slider-button-next--component-blog_3_posts_destaque")
        this.pagination = document.querySelector(".slider-pagination--component-blog_3_posts_destaque")

        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
            pagination: {
                el: this.pagination,
                clickable: true,
                type: "fraction",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                    spaceBetween: 22,
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22,
                },
                768: {
                  slidesPerView: 3.2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 2.99,
                  spaceBetween: 20
                },
                1300: {
                  slidesPerView:3,
                  spaceBetween: 18
                },
            },
        })
    }
}